//import Vue from 'vue'
import Vue from 'vue/dist/vue.js'
import Router from 'vue-router'
import firebase from 'firebase'
import Login from '../components/Login'
import ResetPassword from '../components/ResetPassword'
import Menu from '../components/Menu'
import NewRace from '../components/NewRace'
import GpxImport from '../components/GpxImport'
import CreateDistanceRoute from '../components/CreateDistanceRoute'
import Plotter from '../components/Plotter'
import Main from '../components/Main'
import MapView from '../components/MapView'
import Information from '../components/Information'
import Done from '../components/Done'
import PepPoint from '../components/PepPoint'
import EventKey from '../components/EventKey'
import MyRaces from '../components/MyRaces'
import MyRacesInformation from '../components/MyRacesInformation'
import NoPathEditor from '../components/NoPathEditor'
import Alias from '../components/Alias'

import { store } from '../store/store'

Vue.use(Router)

let router = new Router({
  //mode: 'history',
  routes: [
    {
      path: '*', //redirect paths that does not exists to the Login view
      redirect: '/main'
    },
    {
      path: '/main',
      name: 'Main',
      component: Main,
      props: true,
      children: [
        {
          path: '/login',
          name: 'Login',
          component: Login
        },
        {
          path: '/resetPassword',
          name: 'ResetPassword',
          component: ResetPassword
        },
        {
          path: '/menu',
          name: 'Menu',
          component: Menu,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: '/myraces',
          name: 'MyRaces',
          component: MyRaces,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/myracesinformation',
          name: 'MyRacesInformation',
          component: MyRacesInformation,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/nopatheditor',
          name: 'NoPathEditor',
          component: NoPathEditor,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/newrace',
          name: 'NewRace',
          component: NewRace,
          props: true,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: '/gpximport',
          name: 'GpxImport',
          component: GpxImport,
          props: true,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: '/createdistanceroute',
          name: 'CreateDistanceRoute',
          component: CreateDistanceRoute,
          props: true,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: '/plotter',
          name: 'Plotter',
          component: Plotter,
          props: true,
          meta: {
            requiresAuth: true
          },

        },
        {
          path: '/map',
          name: 'MapView',
          component: MapView,
          props: true,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: '/pep',
          name: 'PepPoint',
          component: PepPoint,
          props: true,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: '/information',
          name: 'Information',
          component: Information,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: '/eventkey',
          name: 'EventKey',
          component: EventKey,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: '/alias',
          name: 'Alias',
          component: Alias,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: '/done',
          name: 'Done',
          component: Done,
          meta: {
            requiresAuth: true
          },
        }
      ]
    },
  ]
})

//This is navigation guarding
router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if(requiresAuth && !currentUser) {
    next('login')
  }
  else if (!requiresAuth && currentUser) {
    console.log("redirect to main")
    next('myraces')
    //next('map')
  }
  else {
    //just proceed with the navigation
    next()
  }
})

export default router
